import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { ChaptersSection } from './components/ChaptersSection';
import { AuthorSection } from './components/AuthorSection';
import { CTASection } from './components/CTASection';
import { PricingSection } from './components/PricingSection';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    if (!window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
    }
    window.fbq('init', '3274690349358017');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-parchment-light text-brown-dark font-serif selection:bg-gold/30 selection:text-forest-dark" data-id="element-0">
      <HeroSection data-id="element-1" />
      <AboutSection data-id="element-2" />
      <ChaptersSection data-id="element-3" />
      <AuthorSection data-id="element-4" />
      <CTASection data-id="element-5" />
      <PricingSection data-id="element-6" />
      <Footer data-id="element-7" />
    </div>;
}